const mpdata2021=[
  {
    Roll: "15BEC061",
    Name: "Maru kiranbhai parshotambhai",
    Project: 'Not Available',
    Guide: "Prof.jayesh patel",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC003",
    Name: "Parmar mayankkumar rajeshbhai",
    Project: "Web development using react js",
    Guide: "Prof. jayesh patel",
    Company: "Software development",
  },
  {
    Roll: "16BEC024",
    Name: "Priyansh shashikant ringe",
    Project: "Development of deep learning algorithms on embedded platform",
    Guide: "Prof. jayesh patel",
    Company: "Ipr",
  },
  {
    Roll: "16BEC025",
    Name: "Chaudhary vaisvikkumar rameshbhai",
    Project: "Gui development irnss receiver ",
    Guide: 'Not Available',
    Company: "Software development ",
  },
  {
    Roll: "17BEC001",
    Name: "Aagam dharmesh jariwala",
    Project:
      "Measurement modeling of standard positioning and precise positioning for satellite-based navigation system",
    Guide: "Dr. manisha upadhyay",
    Company: 'other',
  },
  {
    Roll: "17BEC002",
    Name: "Abhay sharma",
    Project: "Iot converters - rs232-rs485/mqtt to can & vice-versa ",
    Guide: "Prof. dhaval shah",
    Company: "System level solutions (india) pvt. ltd",
  },
  {
    Roll: "17BEC003",
    Name: "Aditya jain",
    Project: "Java full stack development ",
    Guide: "Prof. rachna sharma",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC004",
    Name: "Adodariya kashyap popatbhai",
    Project: "Axi-lite design and verification",
    Guide: "Dr. usha mehta",
    Company: "Einfochips",
  },
  {
    Roll: "17BEC005",
    Name: "Agrini chaturvedi",
    Project: "Java full stack development ",
    Guide: "Prof. rachna sharma",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC006",
    Name: "Ahir aditya rameshbhai",
    Project: "Development of noise monitoring sensor.",
    Guide: "Dr. manish patel",
    Company: "Oizom",
  },
  {
    Roll: "17BEC007",
    Name: "Airan shruti atulkumar",
    Project: "Iot converters - rs232/rs485 to modbus tcp & vice-vers",
    Guide: "Prof. dhaval shah",
    Company: "System level solutions (india) pvt. ltd",
  },
  {
    Roll: "17BEC008",
    Name: "Akshay mishra",
    Project:
      "Measurement modeling of standard positioning and precise positioning for satellite-based navigation system",
    Guide: "Dr. manisha upadhyay",
    Company: 'other',
  },
  {
    Roll: "17BEC009",
    Name: "Aman rajkumar kshatriya",
    Project: "Field analytics",
    Guide: "Dr. vijay savani",
    Company: "Zs associates india pvt. ltd.",
  },
  {
    Roll: "17BEC010",
    Name: "Anant raina",
    Project: "Configuring firmware for wifi chipsets",
    Guide: "Dr. nagendra gajjar",
    Company: "Cypress semiconductor",
  },
  {
    Roll: "17BEC011",
    Name: "Asmita asim kumar barik",
    Project:
      "Evaluation of bq35100 battery fuel gauge and integration into gas meters ",
    Guide: "Dr. piyush bhatasana",
    Company: "Secure meter ltd",
  },
  {
    Roll: "17BEC013",
    Name: "Ayushee samridhi",
    Project: "Verification group training",
    Guide: "Dr. dipesh panchal",
    Company: "Synopsys noida",
  },
  {
    Roll: "17BEC014",
    Name: "Baraiya dhavalkumar kamleshbhai",
    Project: "Intelligent agriculture device",
    Guide: "Prof.bhupendra fataniya",
    Company: "Gelco electronics pvt.ltd.",
  },
  {
    Roll: "17BEC015",
    Name: "Bhanushali meetkumar vasantbhai",
    Project: "Not yet allocated",
    Guide: "Dr. nagendra gajjar",
    Company: "Cypress semiconductor (an infineon company)",
  },
  {
    Roll: "17BEC016",
    Name: "Bhargava arpita sandeep",
    Project: "Java full stack devlopment-industrial training + pet project",
    Guide: "Prof. rachna sharma",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC017",
    Name: "Bhavin patel",
    Project: "Asic design and verification",
    Guide: "Dr. akash mecwan",
    Company: "Cadence design systems",
  },
  {
    Roll: "17BEC018",
    Name: "Bhavsar nirjhari jayvadan",
    Project: "Weed data analytics",
    Guide: "Prof. bhavin kakani",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC019",
    Name: "Bhensdadiya kevin prabhulal",
    Project: "implementation of 7temeter",
    Guide: "Prof. sachin gajjar",
    Company: "Secure meters",
  },
  {
    Roll: "17BEC020",
    Name: "Bohra rohan jagdish",
    Project: "Design and simulation of cmos differential amplifier",
    Guide: "Dr amisha naik",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC022",
    Name: "Chinmay khurana",
    Project: "Not yet alloted",
    Guide: "Prof. twinkle bhavsar",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC023",
    Name: "Desai sapan nikunj",
    Project: "Development of fleet management system using oracle fusion.",
    Guide: "Dr. sachin gajjar",
    Company: "Evosys",
  },
  {
    Roll: "17BEC024",
    Name: "Devansh chawla",
    Project: "Yet to be decided",
    Guide: "Dr. ruchi gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC025",
    Name: "Dholakia himanshu rajeshkumar",
    Project: "The future trends in inventory management",
    Guide: "Prof. rutul patel",
    Company: "Samyak infotech ",
  },
  {
    Roll: "17BEC026",
    Name: "Dhwani rakesh malkan",
    Project: "1. connected machines 2. predictive maintenance",
    Guide: "Prof. rutul patel",
    Company: "L&t, hazira",
  },
  {
    Roll: "17BEC027",
    Name: "Divyesh kalpeshkumar sankhla",
    Project: "Automation using plc",
    Guide: "Dr. y. n. trivedi",
    Company: "Dynemix india",
  },
  {
    Roll: "17BEC028",
    Name: "Dobariya priti bharatbhai",
    Project: "Automation testing in oscilloscope application",
    Guide: "Dr. vijay savani",
    Company: "Keysight technologies",
  },
  {
    Roll: "17BEC029",
    Name: "Gajjar devanshu sanjeevkumar",
    Project: "Automation using plc",
    Guide: "Dr. y. n. trivedi",
    Company: "Dynemix india",
  },
  {
    Roll: "17BEC030",
    Name: "Gangwani gunjan mukesh",
    Project: "Linux training",
    Guide: "Dr. vaishali dhare",
    Company: "Einfochips",
  },
  {
    Roll: "17BEC031",
    Name: "Gautam rashi rajesh",
    Project: "Gui development for irnss receiver. ",
    Guide: "Dr. sachin gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC032",
    Name: "Gurmeet jasvir khurana",
    Project: "Ai ml based spectrum sensing for cognitive radio",
    Guide: "Prof. mangal singh",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC034",
    Name: "Hetanshu gupta",
    Project: "Automation testing in oscilloscope,dmm application",
    Guide: "Prof. rutul patel",
    Company: "Keysight technologies",
  },
  {
    Roll: "17BEC035",
    Name: "Honey nikhil shah",
    Project: "Linux training",
    Guide: "Dr. usha mehta",
    Company: "Einfochips",
  },
  {
    Roll: "17BEC036",
    Name: "Jagrat jhamb",
    Project: "Automation using plc",
    Guide: "Dr. y. n. trivedi",
    Company: "Dynemix india",
  },
  {
    Roll: "17BEC037",
    Name: "Jain dhruv vinodkumar",
    Project: "Pmu baremetal flow and cmsis",
    Guide: "Prof. dipesh panchal",
    Company: "Arm",
  },
  {
    Roll: "17BEC038",
    Name: "Jain khushi purvesh",
    Project: "Computer vision and deep learning domain",
    Guide: "Prof. rutul patel",
    Company: "Softvan",
  },
  {
    Roll: "17BEC039",
    Name: "Jaykumar prafulbhai domadiya",
    Project: "Implemenation of enhanced alu",
    Guide: "Prof. vijay savani",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC040",
    Name: "Jeswani aman jagdish",
    Project: "Automatic test pattern generation",
    Guide: "Dr. vaishali dhare",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC041",
    Name: "Jahnavi jha",
    Project: "Training at l&t + project",
    Guide: "Prof. bhavin kakani",
    Company: "L&t technology and services limited",
  },
  {
    Roll: "17BEC042",
    Name: "Jigyasa mahur",
    Project: "Ai ml based spectrum sensing for cognitive radio",
    Guide: "Prof mangal singh",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC043",
    Name: "Jyotika gurnani",
    Project: "Universal 100w power adapter using usb-c with pps",
    Guide: "N.p gajjar",
    Company: "Cypress semiconductor (an infineon company)",
  },
  {
    Roll: "17BEC045",
    Name: "Kapadia karan maulik",
    Project: "Data analysis using r-programming and tableau",
    Guide: "Prof. yogesh trivedi",
    Company: "Letsbiz",
  },
  {
    Roll: "17BEC046",
    Name: "Kartik jain",
    Project: "Vlsi physical design using open source tool",
    Guide: "Prof. dipesh panchal ",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC047",
    Name: "Kartik madhukeshwar hegde",
    Project: "Not yet alloted",
    Guide: "Dr. manish patel",
    Company: "Agilo research(stempedia)",
  },
  {
    Roll: "17BEC048",
    Name: "Keshav dinesh kasat",
    Project: "Contextual sentiment analysis",
    Guide: "Dr. mangal singh",
    Company: "Effiya technologies",
  },
  {
    Roll: "17BEC049",
    Name: "Kunwar vaibhav",
    Project: "Verification of vip",
    Guide: "Dr. akash mecwan",
    Company: "Cadence design systems",
  },
  {
    Roll: "17BEC050",
    Name: "Kv sai akhilesh",
    Project: "Incentive compensation admin ",
    Guide: "Dr. vijay savani",
    Company: "Zs associates",
  },
  {
    Roll: "17BEC051",
    Name: "Makwana shubham sandipbhai",
    Project: "Iot switch",
    Guide: "Dr dilip kothari",
    Company: "Linked loops",
  },
  {
    Roll: "17BEC052",
    Name: "Malhotra rohan manish",
    Project: "Interactive robot",
    Guide: "Dr. akash mecwan",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC053",
    Name: "Meet singh chauhan",
    Project: "Asic design and verification",
    Guide: "Dr. akash mecwan",
    Company: "Cadence design systems (india) pvt. ltd.",
  },
  {
    Roll: "17BEC054",
    Name: "Miglani manan sunil",
    Project: "A novel speed estimation system using visible light in vehicles",
    Guide: "Dr. yogesh trivedi",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC055",
    Name: "Mishra rajiv sushil",
    Project: "Milk run delivery software",
    Guide: " dr. ruchi gajjar",
    Company: "Hashedin by deloitte",
  },
  {
    Roll: "17BEC056",
    Name: "Naidu hema dinesh",
    Project:
      "Boot process optimization & modifying boot staging for nxt- litem2",
    Guide: "Dr.mangal singh",
    Company: "Ebytelogic",
  },
  {
    Roll: "17BEC057",
    Name: "Naik meet dipakbhai",
    Project: "Tcs xplore training and pet project",
    Guide: "Dr mangal singh",
    Company: "Tcs",
  },
  {
    Roll: "17BEC058",
    Name: "Navadiya pratikkumar mukeshbhai",
    Project:
      " vlsi physical design using open source tool (inhouse project) & tcs xplore training ",
    Guide: "Prof. dipesh panchal",
    Company: "Tcs",
  },
  {
    Roll: "17BEC059",
    Name: "Nishith ranabhai poshiya",
    Project: "Data science ",
    Guide: "Dr. vijay savani",
    Company: "Hashcrypt technologies",
  },
  {
    Roll: "17BEC060",
    Name: "Padiya jeel rajesh",
    Project: "Advance java-adm",
    Guide: " prof. twinkle bhavsar",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC061",
    Name: "Pahal chhapiya",
    Project: "Home automation system ",
    Guide: "Dr. piyush bhatasana",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC062",
    Name: "Parghi anandi chandulal",
    Project: "A novel speed estimation system using visible light in vehicles",
    Guide: "Prof.  yogesh trivedi",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC063",
    Name: "Parikh tirth keyurkumar",
    Project: "Product based embedded work",
    Guide: "Dr.ruchi gajjar",
    Company: "Emsys technologies",
  },
  {
    Roll: "17BEC064",
    Name: "Patel deep hiteshbhai",
    Project: "Design and simulation of cmos differential amplifier",
    Guide: "Dr. amisha naik",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC065",
    Name: "Patel hemang harishbhai",
    Project: "Tcs xplore training and pet project",
    Guide: "Dr. akash mecwan",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC066",
    Name: "Patel mansi amishkumar",
    Project:
      "Evaluation of bq35100 battery fuel gauge and integration into gas meters ",
    Guide: "Dr. piyush bhatasana",
    Company: "Secure meters ltd.",
  },
  {
    Roll: "17BEC067",
    Name: "Patel mosam mukeshbhai",
    Project:
      "Develop an edge device application to detect objects using deep learning",
    Guide: "Dr. dhaval shah",
    Company: "System level solutions (india) pvt. ltd",
  },
  {
    Roll: "17BEC068",
    Name: "Patel nikhilkumar pareshbhai",
    Project: " psychological analysis using sentiment and emotion mapping ",
    Guide: "Dr. nagendra gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC069",
    Name: "Patel pratyusha",
    Project: "Digital pre-distortion techniques for satellite communication",
    Guide: "Dr. manisha upadhyay",
    Company: "Sac-isro",
  },
  {
    Roll: "17BEC070",
    Name: "Patel yashkumar girishkumar",
    Project: "Iot based health monitoring system",
    Guide: "Dr. dilip kothari",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC071",
    Name: "Prajapati kush bharatkumar",
    Project: "Visible light communication",
    Guide: "Prof. twinkle bhavsar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC072",
    Name: "Pranshu jain",
    Project: " development of e-learning platform using angular",
    Guide: "Prof. hardik josh",
    Company: "Zeus learning",
  },
  {
    Roll: "17BEC073",
    Name: "Praveen kukreja",
    Project: "Chronicle cbn parser",
    Guide: "Dr. mangal singh",
    Company: "Crest  data systems",
  },
  {
    Roll: "17BEC074",
    Name: "Pravishty maheshwari",
    Project: "Training on msbi",
    Guide: "Prof twinkle bhavasar",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC075",
    Name: "Priyam patel",
    Project: "Ai in healthcare",
    Guide: "Prof. manish patel",
    Company: "Logy.ai",
  },
  {
    Roll: "17BEC076",
    Name: "Pujara deep dhavalbhai",
    Project: "Modulation scheme identification (exact not decided)",
    Guide: "Dr. manisha upadhyay",
    Company: "Sac-isro",
  },
  {
    Roll: "17BEC077",
    Name: "Rajat goyal",
    Project: "Facial recognition using ml",
    Guide: "Prof. rutul patel",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC078",
    Name: "Rakholiya abhishek amarutkumar",
    Project: "Internship + pet project: solar tracking system",
    Guide: "Prof. hardik josh",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC079",
    Name: "Rakkshab varadharajan iyer",
    Project: "Multi band antenna",
    Guide: "Prof. piyush bhatasana",
    Company: "Secure meters",
  },
  {
    Roll: "17BEC080",
    Name: "Ramani vatsal pravinbhai",
    Project: 'Not Available',
    Guide: "Prof. bhupendra fataniya",
    Company: "Gelco elctronics pvt ltd.",
  },
  {
    Roll: "17BEC081",
    Name: "Ramika chakhaiyar",
    Project: "Deep dive in data analysis via tableau software",
    Guide: "Dr. vijay savani",
    Company: "Zs associates ",
  },
  {
    Roll: "17BEC082",
    Name: "Risha singh",
    Project: "Evolving backhaul solutions for lte and 5g technologies",
    Guide: "Prof. bhavin kakani",
    Company: "Bharti airtel",
  },
  {
    Roll: "17BEC083",
    Name: "Rishabh khabya",
    Project: "Design and verification of amba3 ahb lite using verilog",
    Guide: "Prof. usha mehta",
    Company: "Einfochips",
  },
  {
    Roll: "17BEC084",
    Name: "Rishabh sharma",
    Project: "Not yet alloted",
    Guide: "Prof. hardik joshi",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC085",
    Name: "Rishabh hiren patadia",
    Project: "Fullstack web development",
    Guide: "Twinkle k. bhavsar",
    Company: "Nysha solutions",
  },
  {
    Roll: "17BEC086",
    Name: "Rishi mehul pandya",
    Project: "Equity research using technical and regression analysis",
    Guide: "Dr. dhaval pujara",
    Company: "Iim ahmedabad",
  },
  {
    Roll: "17BEC087",
    Name: "Rishiraj singh rathore",
    Project: "Visible light communication",
    Guide: "Porf.twinkle k. bhavsar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC088",
    Name: "Rohan gupta",
    Project: "Psychological analysis using sentiment and emotion mapping ",
    Guide: "Dr. nagendra gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC089",
    Name: "Rohan kumar patel",
    Project: "Not yet alloted",
    Guide: "Dr. ruchi gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC091",
    Name: "Sagar ashok maheshwari",
    Project:
      "Performance optimization for ai engine on versal adaptive compute acceleration platform",
    Guide: "Prof bhavin kakani",
    Company: "Xilinx",
  },
  {
    Roll: "17BEC092",
    Name: "Sagar biren patel",
    Project: "Amba 3 ahb lite protocol design and verification",
    Guide: "Prof vaishali dhare",
    Company: "E-infochips",
  },
  {
    Roll: "17BEC093",
    Name: "Sahil tulsiani",
    Project: "Stock price prediction using ml",
    Guide: "Prof. hardik joshi",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC094",
    Name: "Sameer ravi kanth",
    Project: "Stock price prediction using ml ",
    Guide: "Prof. hardik joshi",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC095",
    Name: "Saumya borwankar",
    Project: "Respiratory pathology detection with audio using ml",
    Guide: "Prof. manish patel",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC096",
    Name: "Saurav kiritbhai dekhtawala",
    Project: "Not yet alloted",
    Guide: "Prof. vaishali dhare",
    Company: "E-infochips",
  },
  {
    Roll: "17BEC097",
    Name: "Shah dhruv milan",
    Project: "Quality assurance and engineering training",
    Guide: "Prof. hardik joshi",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC098",
    Name: "Shah hiral nayan",
    Project: "Gan network based image super resolution",
    Guide: "Prof. bhupendra fataniya",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC099",
    Name: "Shah jainam nileshbhai",
    Project: "Asset location tracking using ultra-wide band",
    Guide: "Prof. ruchi gajjar",
    Company: "Glide technology",
  },
  {
    Roll: "17BEC100",
    Name: "Shah ruchit bankimbhai",
    Project: "Product based embedded work",
    Guide: "Prof. rachna sharma",
    Company: "Emsys technologies",
  },
  {
    Roll: "17BEC101",
    Name: "Shah samyak pranavbhai",
    Project: "Asset location tracking using ultra-wide band",
    Guide: "Prof. ruchi gajjar",
    Company: "Glide technology",
  },
  {
    Roll: "17BEC102",
    Name: "Shah udit tejas",
    Project:
      "Development of epics based control system on low cost embedded platform",
    Guide: "Dr. dhaval pujara",
    Company: "Institute for plasma research",
  },
  {
    Roll: "17BEC103",
    Name: "Shaikh rehan alam shahnawaz alam",
    Project: "Analysis of data from wireless sensor nodes",
    Guide: "Prof. rutul patel",
    Company: "Atoll solutions",
  },
  {
    Roll: "17BEC104",
    Name: "Sharma devang yogesh",
    Project: "Mppt algorithms research and development.",
    Guide: "Dr. dilip kothari",
    Company: "System level solutions (india) pvt. ltd",
  },
  {
    Roll: "17BEC105",
    Name: "Sharma himanshu govardhan",
    Project: "Arm development boards' software stack",
    Guide: "Prof. dipesh panchal",
    Company: "Arm embedded technologies",
  },
  {
    Roll: "17BEC106",
    Name: "Shivangi manish shah",
    Project:
      "Ber analysis of futuristic higher-order modulation schemes for different fading models. ",
    Guide: "Rachna sharma",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC108",
    Name: "Shraddha pandey",
    Project:
      "1. internship (microsoft business intelligence) 2. pet project (diabetes prediction using cxrs and deep learning )",
    Guide: "Dr. manish patel",
    Company: "Cognizant",
  },
  {
    Roll: "17BEC109",
    Name: "Shrey bhatnagar",
    Project: "Obstacle avoidance algorithm",
    Guide: "Prof. dhaval shah",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC110",
    Name: "Shreya chandrasekhar",
    Project: "Synthetic aperture radar tomography",
    Guide: "Dr. manisha upadhyay",
    Company: "Sac - isro",
  },
  {
    Roll: "17BEC111",
    Name: "Shruti goel",
    Project: "Development of podem algorithm",
    Guide: "Dr. usha mehta",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC112",
    Name: "Shwet mitesh shah",
    Project: "Automatic test pattern generator",
    Guide: "Dr. vaishali dhare",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC113",
    Name: "Soma aditya mahesh",
    Project: "Gan network based image super resolution",
    Guide: "Prof. bhupendra fataniya",
    Company: 'other',
  },
  {
    Roll: "17BEC116",
    Name: "Tarun kishore khilani",
    Project: "Stock prediction using reinforcement learning",
    Guide: 'Not Available',
    Company: "Geeky bee ai",
  },
  {
    Roll: "17BEC117",
    Name: "Thaker poojan shaileshhai",
    Project: "Obstacle avoidance algorithm",
    Guide: "Prof. dhaval shah",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC118",
    Name: "Thakor vaibhavkumar jigneshkumar",
    Project: "Image segmentation on soccer game and ocr for id verification",
    Guide: "Dr. dhaval pujara",
    Company: "Aimonk labs",
  },
  {
    Roll: "17BEC119",
    Name: "Tripathi surbhi niteshbhai",
    Project: "Development of podem algorithm",
    Guide: "Dr. usha mehta",
    Company: "Inhouse",
  },
  {
    Roll: "17BEC120",
    Name: "Trivedi jay divyakant",
    Project: "Development of edge and connectivity solutions for iiot",
    Guide: "Dr. dilip kothari",
    Company: "Scitech centre, acg",
  },
  {
    Roll: "17BEC121",
    Name: "Upadhyay shivanshu rajiv kumar",
    Project: "Porting android \nemail app to windows\n",
    Guide: "Dr. dilip kothari",
    Company: "Canary mail",
  },
  {
    Roll: "17BEC122",
    Name: "Vaghani darshankumar nareshbhai",
    Project: "Design of  minimips using verilog",
    Guide: "Dr. sachin gajjar",
    Company: "Cadence design system",
  },
  {
    Roll: "17BEC124",
    Name: "Vaidya gargee hemantkumar",
    Project:
      "Machine learning and computer vision for augmented reality based applications",
    Guide: "Dr.amisha naik",
    Company: "Melzo (shilpmis technologies pvt. ltd.)",
  },
  {
    Roll: "17BEC126",
    Name: "Vatsal jain",
    Project: "Sales,analytics.        ",
    Guide: "Dr.amisha naik",
    Company: "Hexco global usa llc",
  },
  {
    Roll: "17BEC127",
    Name: "Yash deepak shamnani",
    Project: "Happierwork",
    Guide: "Dr. amisha naik",
    Company: "Search logistics",
  },
  {
    Roll: "17BEC151",
    Name: "Bhatnagar siddhant vinod",
    Project:
      "Ber analysis of futuristic higher-order modulation schemes for different fading models.",
    Guide: "Prof. rachna sharma",
    Company: "Inhouse",
  },
  {
    Roll: "18BEC151",
    Name: "Goradiya vatsal akshaybhai",
    Project: "Iot based health monitoring system",
    Guide: "Dr. dilip kothari",
    Company: "Inhouse",
  },
  {
    Roll: "18BEC152",
    Name: "Parmar kajalben natvarbhai",
    Project: 'Not Available',
    Guide: "Prof. bhupendra fataniya",
    Company: "Gelco electronics pvt. ltd.",
  },
];


export default mpdata2021;